import { PlayerCardsContextData } from "./PlayerCardsContext";
import { UserContextData } from "./UserContext";
import { PlayerCardWidget, SmartLink, SmartLinkServices } from "@/services/bedrock";
import { createInitialRecordContextData, createRecordContextData, RecordContextData } from "./RecordContext";

export interface SmartLinkContextData extends RecordContextData<SmartLink> {}

export const InitialSmartLinkContextData: SmartLinkContextData = createInitialRecordContextData<SmartLink>();

const fetchPage = (_playerId: number, page: number, perPage: number, search?: string) => {
  return SmartLinkServices.getSmartLinks({
    isActive: true,
    search,
    page,
    perPage,
  });
};

const getRecordFromWidget = (w: PlayerCardWidget): SmartLink | null => {
  return w.owner?.type === "SmartLink" ? w.owner.smartLink ?? null : null;
};

const isRecordNewer = (record: SmartLink, otherRecord?: SmartLink) => {
  if (!otherRecord) return true;
  return record.createdDate > otherRecord.createdDate;
};

export const SmartLinkContext = (PlayerCards: PlayerCardsContextData, User: UserContextData): SmartLinkContextData => {
  return createRecordContextData<SmartLink>(
    PlayerCards,
    User,
    "SmartLink",
    fetchPage,
    getRecordFromWidget,
    isRecordNewer
  );
};
